import type { ShortAnswerQuestion as ShortAnswerType } from '@/types';

interface Props {
  question: ShortAnswerType;
  answer: string;
  onAnswer: (questionId: string, answer: string) => void;
  showResults: boolean;
}

export default function ShortAnswerQuestion({ question, answer, onAnswer, showResults }: Props) {
  return (
    <div className="quiz-question short-answer-question">
      <p className="question-text">{question.question}</p>
      <textarea
        className="short-answer-input"
        value={answer}
        onChange={(e) => !showResults && onAnswer(question.id, e.target.value)}
        placeholder="Type your answer here..."
        rows={4}
        disabled={showResults}
      />
      {showResults && (
        <div className="question-explanation">
          <strong>Note:</strong> Short answer questions are reviewed by AI or your instructor.
          {question.sampleAnswer && (
            <div className="sample-answer">
              <strong>Sample answer:</strong> {question.sampleAnswer}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
